import { bootstrapApplication } from '@angular/platform-browser';
import { appConfigFactory } from './app/app.config';
import { AppComponent } from './app/app.component';

// eslint-disable-next-line no-console
bootstrapApplication(AppComponent, appConfigFactory()).catch((err) => console.error(err));
